// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1de9117","buttons":"_b16688b","priceUpdates":"_ee380f3","icon":"_6e58399"};